import { useToasts } from 'react-toast-notifications';
import { useQuery } from '@apollo/react-hooks';

import { VIEWER_QUERY } from './queries';
import useLogout from './useLogout';

const useViewer = () => {
  const { addToast } = useToasts();
  const { logout } = useLogout();

  const { data: { viewer } = {}, loading, error } = useQuery(VIEWER_QUERY, {
    onCompleted: (data) => {
      if (data && data.viewer === null) {
        logout();
      }
    },
    onError: (err) => {
      console.log(err);
      if (err.graphQLErrors) {
        err.graphQLErrors.forEach((e) => {
          if (
            (e.message.includes('You do not have access to this resource') || e.name === 'AccessDeniedError')
            && e.path.length === 0
            && (e.path[0] === 'viewer' || e.path[0] === 'authenticatedCustomer')
          ) {
            addToast('You are not signed in', {
              appearance: 'error',
              autoDismiss: true,
              autoDismissTimeout: 10000,
            });
            logout();
          }
        });
      } else {
        logout();
        addToast('Something unexpected happened, Try Again later', {
          appearance: 'error',
          autoDismiss: true,
        });
      }
    },
  });

  return {
    viewer,
    error,
    loading,
  };
};

export default useViewer;
